
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Announcement from "../components/Announcement";
import FixMenu from "../components/FixMenu";
import Header from "../components/Header";
const steps = [
  {
    title:
      "Tariff Petition for True-Up FY 2023-24, APR FY 2024-25 & ARR/Tariff FY 2025-26",
  },
  {
    title: "Revised Petition For ARR FY 2025-26",
  },
  {
    title: "Reply to Deficiency Note-1",
    date: null,
  },
  {
    title: "Reply to Deficiency Note-2",
    date: null,
  },
  {
    title: "Reply to TVS MoM",
    date: null,
  },
  {
    title: "Reply to Deficiency Note-3",
    date: null,
  },
];

const deficiencyNote3 = [
  {
    name: "1.Cover Letter DN-3",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/1.Cover Letter DN-3.pdf",
  },
  {
    name: "2.Affidavit DN-3",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/2.Affidavit DN-3.pdf",
  },
  {
    name: "3.Appendix-1 Reply to DN-3",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/3.Appendix-1 Reply to DN-3.pdf",
  },
  {
    name: "4.Annexure-1 Revised Form P1",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/4.Annexure-1 Revised Form P1.pdf",
  },
  {
    name: "4.Annexure-1 Revised Form P1",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/4.Annexure-1 Revised Form P1.xlsx",
  },
  {
    name: "5.Annexure-2 GNIDA Letters reagrding NOC before granting electricity connection",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/5.Annexure-2 GNIDA Letters reagrding NOC before granting electricity connection.pdf",
  },
  {
    name: "6.Annexure-3 Actual Bills for CIL & Additional Coal",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/6.Annexure-3 Actual Bills for CIL & Additional Coal.pdf",
  },
  {
    name: "7.Annexure-4 Actual Bills APPCPL",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/7.Annexure-4 Actual Bills APPCPL.pdf",
  },
  {
    name: "8.Annexure-5 Breakup of RE from Exchange",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/8.Annexure-5 Breakup of RE from Exchange.pdf",
  },
  {
    name: "8.Annexure-5 Breakup of RE from Exchange",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/8.Annexure-5 Breakup of RE from Exchange.xlsx",
  },
  {
    name: "9.Annexure-6 Certificate of GDAM purchase",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/9.Annexure-6 Certificate of GDAM purchase.pdf",
  },
  {
    name: "10.Annexure-7 No. of Employee and audited Expenses",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/10.Annexure-7 No. of Employee and audited Expenses.pdf",
  },
  {
    name: "10.Annexure-7 No. of Employee and audited Expenses",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/10.Annexure-7 No. of Employee and audited Expenses.xlsx",
  },
  {
    name: "11.Annexure-8 Normative EE based on No. of Employee FY26",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/11.Annexure-8 Normative EE based on No. of Employee FY26.pdf",
  },
  {
    name: "11.Annexure-8 Normative EE based on No. of Employee FY26",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/11.Annexure-8 Normative EE based on No. of Employee FY26.xlsx",
  },
  {
    name: "12.Annexure-9 Energy Balance as per Commissions direction in TO 10.10.2024",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/12.Annexure-9 Energy Balance as per Commissions direction in TO 10.10.2024.pdf",
  },
  {
    name: "12.Annexure-9 Energy Balance as per Commissions direction in TO 10.10.2024",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-3/12.Annexure-9 Energy Balance as per Commissions direction in TO 10.10.2024.xlsx",
  },
]

const deficiencyNote1 = [
  {
    name: "0. Cover Letter DN-1",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/0. Cover Letter DN-1.pdf",
  },
  {
    name: "1. Affidavit DN-1",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/1. Affidavit DN-1.pdf",
  },
  {
    name: "2.NPCL Reply to DN1 ARR FY26_17.02.2025",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/2.NPCL Reply to DN1 ARR FY26_17.02.2025.pdf",
  },
  {
    name: "3.Annexure-1 Details of energy managed through net metering on monthly basis",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/3.Annexure-1 Details of energy managed through net metering on monthly basis.xlsx",
  },
  {
    name: "4.Annexure-2 Energy Balance Linked File",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/4.Annexure-2 Energy Balance Linked File.xlsx",
  },
  {
    name: "5.Annexure-3 Reconciliation of Power Purchase Cost (FY-24)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/5.Annexure-3 Reconciliation of Power Purchase Cost (FY-24).xlsx",
  },
  {
    name: "6.Annexure-4 DSM Reconciliation and Time Block Data",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/6.Annexure-4 DSM Reconciliation and Time Block Data.xlsx",
  },
  {
    name: "7.Annexure-5 Summary of SLDC Bills",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/7.Annexure-5 Summary of SLDC Bills.xlsx",
  },
  {
    name: "8.Annexure-6 Computation of fixed Charges(FY24)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/8.Annexure-6 Computation of fixed Charges(FY24).xlsx",
  },
  {
    name: "9.Annexure-7 Computation of Energy Charges (FY24)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/9.Annexure-7 Computation of Energy Charges (FY24).xlsx",
  },
  {
    name: "10.Annexure-8 Month-wise Declared Availability TPTCL (FY24)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/10.Annexure-8 Month-wise Declared Availability TPTCL (FY24).xlsx",
  },
  {
    name: "11.Annexure-9 Expenses incurred on account of SOP implementation (FY24)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/11.Annexure-9 Expenses incurred on account of SOP implementation (FY24).xlsx",
  },
  {
    name: "12.Annexure-10 Reconcillation of Losses (FY24)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/12.Annexure-10 Reconcillation of Losses (FY24).xlsx",
  },
  {
    name: "13.Annexure-11 SLDC application fee for (FY24)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/13.Annexure-11 SLDC application fee for (FY24).xlsx",
  },
  {
    name: "14.Annexure-12 Demand Estimate FY26",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/14.Annexure-12 Demand Estimate FY26.xlsx",
  },
  {
    name: "15.Annexure-13 Tariff Forms FY24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/15.Annexure-13 Tariff Forms FY24.xlsx",
  },
  {
    name: "16.Annexure-14 List of Open Access Consumers - Linked",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/3.Deficiency Note-1/16.Annexure-14 List of Open Access Consumers - Linked.xlsx",
  },
];

const deficiencyNote2 = [
  {
    name: "0.Cover Letter DN-2",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/4.Deficiency Note-2/0.Cover Letter DN-2.pdf",
  },
  {
    name: "1.Affidavit DN-2",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/4.Deficiency Note-2/1.Affidavit DN-2.pdf",
  },
  {
    name: "2.Appendix-1 Reply to DN-2",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/4.Deficiency Note-2/2.Appendix-1 Reply to DN-2.pdf",
  },
  {
    name: "3.Annexure-1 DIL mail dated 31.01.2024",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/4.Deficiency Note-2/3.Annexure-1 DIL mail dated 31.01.2024.pdf",
  },
  {
    name: "4.Annexure-2 MPL and Company Letter dated 31.01.2024",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/4.Deficiency Note-2/4.Annexure-2 MPL and Company Letter dated 31.01.2024.pdf",
  },
  {
    name: "5.Annexure-3 MPL invoice dated 02.02.2024",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/4.Deficiency Note-2/5.Annexure-3 MPL invoice dated 02.02.2024.pdf",
  },
  {
    name: "6.Annexure-4 NPCL debit note dated 06.02.2024",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/4.Deficiency Note-2/6.Annexure-4 NPCL debit note dated 06.02.2024.pdf",
  },
  {
    name: "7.Annexure-5 DIL_MPL_Power capacity_PLF",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/4.Deficiency Note-2/7.Annexure-5 DIL_MPL_Power capacity_PLF.pdf",
  },
  {
    name: "9.Annexure-6 Adani Green Energy Invoice & Documents",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/4.Deficiency Note-2/9.Annexure-6 Adani Green Energy Invoice & Documents.pdf",
  },
  {
    name: "10.Annexure-7 Arrear Invoice RS. 1.74 Cr. CTUIL_JAN'22 TO MARCH'22",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/4.Deficiency Note-2/10.Annexure-7 Arrear Invoice RS. 1.74 Cr. CTUIL_JAN'22 TO MARCH'22.pdf",
  },
  {
    name: "11.Annexure-8 TPTCL Transmission Chg. Exp for FY23 & booked in FY24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/4.Deficiency Note-2/11.Annexure-8 TPTCL Transmission Chg. Exp for FY23 & booked in FY24.pdf",
  },
  {
    name: "12.Annexure-9 Reconciliation of Power Purchase Cost (FY-24)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/4.Deficiency Note-2/12.Annexure-9 Reconciliation of Power Purchase Cost (FY-24).pdf",
  },
  {
    name: "13.Annexure-9 Reconciliation of Power Purchase Cost (FY-24)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/4.Deficiency Note-2/13.Annexure-9 Reconciliation of Power Purchase Cost (FY-24).xlsx",
  },
];

const secondStep = [
  {
    name: "0. Cover Letter Revised ARR FY 2025-26",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/0. Cover Letter Revised ARR FY 2025-26.pdf",
  },
  {
    name: "1. Petition in Form-1 Revised ARR FY 2025-26",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/1. Petition in Form-1 Revised ARR FY 2025-26.pdf",
  },
  {
    name: "2. Petition in Form-2 Revised ARR FY 2025-26",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/2. Petition in Form-2 Revised ARR FY 2025-26.pdf",
  },
  {
    name: "5. Appendix-II Revised Tariff Formats ARR FY 2025-26",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/5. Appendix-II Revised Tariff Formats ARR FY 2025-26.xlsx",
  },
  {
    name: "8. Appendix-V Text of Revised ARR FY 2025-26",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/8. Appendix-V Text of Revised ARR FY 2025-26.pdf",
  },
  {
    name: "9. Appendix-VI  Revised Cost Allocation",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/9. Appendix-VI  Revised Cost Allocation.pdf",
  },
  {
    name: "13. Appendix-X(a) Draft Public Notice (English)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/13. Appendix-X(a) Draft Public Notice (English).pdf",
  },
  {
    name: "14. Appendix-X(b) Draft Public Notice (Hindi)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/14. Appendix-X(b) Draft Public Notice (Hindi).pdf",
  },
  {
    name: "15. Appendix-XI Revised Executive Summary",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/15. Appendix-XI Revised Executive Summary.pdf",
  },
  {
    name: "16.Annexure-I Letter Dated 21.03.2025_to ACS Energy regarding LMV-5 subsidy",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/16.Annexure-I Letter Dated 21.03.2025_to ACS Energy regarding LMV-5 subsidy.pdf",
  },
  {
    name: "17.Annexure-II MT_Maa Durga & MPL (BLA Power) approval order",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/17.Annexure-II MT_Maa Durga & MPL (BLA Power) approval order.pdf",
  },
  {
    name: "18.Annexure-II ST_Pt-no-2187of2025NPCL-02-04-2025-PDF422025",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/18.Annexure-II ST_Pt-no-2187of2025NPCL-02-04-2025-PDF422025.pdf",
  },
  {
    name: "19.Annexure-III MT_Maa Durga & MPL (BLA Power) approval order - Copy",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/19.Annexure-III MT_Maa Durga & MPL (BLA Power) approval order - Copy.pdf",
  },
  {
    name: "20.Annexure-III MT_Pt-no-2202of2025NPCL-02-04-2025-Sai Lilagar & DIL",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/20.Annexure-III MT_Pt-no-2202of2025NPCL-02-04-2025-Sai Lilagar & DIL.pdf",
  },
  {
    name: "21.Annexure-IV ST_Pt-no-2194of2025NPCL-03-04-2025-PDF432025",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/21.Annexure-IV ST_Pt-no-2194of2025NPCL-03-04-2025-PDF432025.pdf",
  },
  {
    name: "22.Annexure-IX UPERC Order in Petition No. 2089 of 2024",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/22.Annexure-IX UPERC Order in Petition No. 2089 of 2024.pdf",
  },
  {
    name: "23.Annexure-V RPO Computation in the format prescribed by the Honble Commission",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/23.Annexure-V RPO Computation in the format prescribed by the Honble Commission.pdf",
  },
  {
    name: "24.Annexure-V RPO Computation in the format prescribed by the Honble Commission",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/24.Annexure-V RPO Computation in the format prescribed by the Honble Commission.xlsx",
  },
  {
    name: "25.Annexure-VI  Forum of Regulators Report on O&M Expenses",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/25.Annexure-VI  Forum of Regulators Report on O&M Expenses.pdf",
  },
  {
    name: "26.Annexure-VII O&M_Benchmarking for Discoms_CEA_Guidelines",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/26.Annexure-VII O&M_Benchmarking_for_Discoms_CEA_Guidelines.pdf",
  },
  {
    name: "27.Annexure-VIII ARR FY 25-26 Capital Expenditure Plan",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/27.Annexure-VIII ARR FY 25-26 Capital Expenditure Plan.pdf",
  },
  {
    name: "28.Annexure-VIII ARR FY 25-26 Capital Expenditure Plan",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/28.Annexure-VIII ARR FY 25-26 Capital Expenditure Plan.xlsx",
  },
  {
    name: "29.Annexure-X Estimation of Consumer Contribution",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/29.Annexure-X Estimation of Consumer Contribution.pdf",
  },
  {
    name: "30.Annexure-X Estimation of Consumer Contribution",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/30.Annexure-X Estimation of Consumer Contribution.xlsx",
  },
  {
    name: "31.Annexure-XI Depreciation as per UPERC Method",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/31.Annexure-XI Depreciation as per UPERC Method.pdf",
  },
  {
    name: "32.Annexure-XI Depreciation as per UPERC Method",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/32.Annexure-XI Depreciation as per UPERC Method.xlsx",
  },
  {
    name: "33.Annexure Detailed Project Report (DPR)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/2. Revised Petition for ARR 2025-26 dated 30.04.2025/33.Annexure Detailed Project Report (DPR).pdf",
  },
];

const revisedArrDocuments = [
  {
    name: "0. Cover Letter ARR FY 2025-26",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/0. Cover Letter ARR FY 2025-26.pdf",
  },
  {
    name: "0. Index Page - Tariff Petition FY 2025-26",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/0. Index Page - Tariff Petition FY 2025-26.xlsx",
  },
  {
    name: "0. Petition Fee ARR 2025-26",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/0. Petition Fee ARR 2025-26.pdf",
  },
  {
    name: "1. Petition in Form-1 ARR FY 2025-26",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/1. Petition in Form-1 ARR FY 2025-26.pdf",
  },
  {
    name: "2. Petition in Form-2",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/2. Petition in Form-2.pdf",
  },
  {
    name: "3. Appendix-I(a)  Power of Attorney",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/3. Appendix-I(a)  Power of Attorney.pdf",
  },
  {
    name: "4. Appendix-I(b) Board Resulotion dt. 28th August 2024",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/4. Appendix-I(b) Board Resulotion dt. 28th August 2024.pdf",
  },
  {
    name: "5. Appendix-II MYT Tariff Formats ARR FY 2025-26",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/5. Appendix-II MYT Tariff Formats ARR FY 2025-26 .xlsx",
  },
  {
    name: "6. Appendix-III Text of True UP FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/6. Appendix-III Text of True UP FY 2023-24 .pdf",
  },
  {
    name: "7. Appendix-IV Text of APR FY 2024-25",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/7. Appendix-IV Text of APR FY 2024-25.pdf",
  },
  {
    name: "8. Appendix-V Text of ARR FY 2025-26",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/8. Appendix-V Text of ARR FY 2025-26.pdf",
  },
  {
    name: "9. Appendix-VI  Cost Allocation",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/9. Appendix-VI  Cost Allocation .pdf",
  },
  {
    name: "10. Appendix-VII Compliance Hon'ble Commission's Directives",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/10. Appendix-VII Compliance Hon'ble Commission's Directives.pdf",
  },
  {
    name: "11. Appendix-VIII Additional MYT Format-I",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/11. Appendix-VIII Additional MYT Format-I.xlsx",
  },
  {
    name: "12. Appendix-IX Additional MYT  Formats - II",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/12. Appendix-IX Additional MYT  Formats - II.pdf",
  },
  {
    name: "13. Appendix-X(a) Draft Public Notice (English)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/13. Appendix-X(a) Draft Public Notice (English).pdf",
  },
  {
    name: "14. Appendix-X(b) Draft Public Notice (Hindi)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/14. Appendix-X(b) Draft Public Notice (Hindi).pdf",
  },
  {
    name: "15. Appendix-XI Executive Summary",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/15. Appendix-XI Executive Summary.pdf",
  },
  {
    name: "16. Appendix-XII Soft Copy of Petition",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/16. Appendix-XII Soft Copy of Petition.pdf",
  },
  {
    name: "17. Annexure-1(a) NPCL Audited Accounts FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/17. Annexure-1(a) NPCL Audited Accounts FY 2023-24.pdf",
  },
  {
    name: "18. Annexure-1(b) NPCL Cost Audit Report FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/18. Annexure-1(b) NPCL Cost Audit Report FY 2023-24.pdf",
  },
  {
    name: "19. Annexure-2 GoUP Subsidy Letter",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/19. Annexure-2 GoUP Subsidy Letter.pdf",
  },
  {
    name: "20. Annexure-3 Company letter to GoUP for release of subsidy FY 23-24 & FY 24-25",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/20. Annexure-3 Company letter to GoUP for release of subsidy FY 23-24 & FY 24-25.pdf",
  },
  {
    name: "21. Annexure-4 Details of Saubhagya Consumer",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/21. Annexure-4 Details of Saubhagya Consumer.xlsb",
  },
  {
    name: "22. Annexure-5 Details of Lifeline Consumer",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/22. Annexure-5 Details of Lifeline Consumer.xlsx",
  },
  {
    name: "23. Annexure-6 Details of energy managed through net metering on monthly basis",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/23. Annexure-6 Details of energy managed through net metering on monthly basis.xlsx",
  },
  {
    name: "24. Annexure-7 GNIDA Letters reagrding NOC before granting electricity connection",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/24. Annexure-7 GNIDA Letters reagrding NOC before granting electricity connection.pdf",
  },
  {
    name: "25. Annexure-8 Order related to auxiliary consumption revised  from 15% to 8.5%",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/25. Annexure-8 Order related to auxiliary consumption revised  from 15% to 8.5%.pdf",
  },
  {
    name: "26. Annexure-9  Order dt. 06.05.20 Additional Coal FY-19 Petition No. 1438 of 2019",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/26. Annexure-9  Order dt. 06.05.20 Additional Coal FY-19 Petition No. 1438 of 2019.pdf",
  },
  {
    name: "27. Annexure-10 Order dt. 29.05.20 Change in Law FY 19 Petition No. - 1440 of 2019",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/27. Annexure-10 Order dt. 29.05.20 Change in Law FY 19 Petition No. - 1440 of 2019.pdf",
  },
  {
    name: "28. Annexure-11 Order dt. 21.09.22 towards Change in Law for FY 2023-24 ",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/28. Annexure-11 Order dt. 21.09.22 towards Change in Law for FY 2023-24 .pdf",
  },
  {
    name: "29. Annexure-12 Order dt. 02.05.24 towards Additional Coal for FY 2022-23",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/29. Annexure-12 Order dt. 02.05.24 towards Additional Coal for FY 2022-23.pdf",
  },
  {
    name: "30. Annexure-13 Order dt. 13.06.23 towards Additional Coal for FY 2021-22",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/30. Annexure-13 Order dt. 13.06.23 towards Additional Coal for FY 2021-22.pdf",
  },
  {
    name: "31. Annexure-14 Order dt. 12.05.23 towards Change in Law for FY 2020-21",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/31. Annexure-14 Order dt. 12.05.23 towards Change in Law for FY 2020-21.pdf",
  },
  {
    name: "32. Annexure-15 Order dt. 13.06.23 towards Change in Law for FY 2021-22",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/32. Annexure-15 Order dt. 13.06.23 towards Change in Law for FY 2021-22.pdf",
  },
  {
    name: "33. Annexure-16  NPCL's Copies of Letter  dated 27th October, 2016 and 17th March, 2017 for installation of Solar Rooftop",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/33. Annexure-16  NPCL's Copies of Letter  dated 27th October, 2016 and 17th March, 2017 for installation of Solar Rooftop.pdf",
  },
  {
    name: "34. Annexure-17 RPO Computation in the format prescribed by the Hon'ble Commission ",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/34. Annexure-17 RPO Computation in the format prescribed by the Hon'ble Commission.xlsx",
  },
  {
    name: "35. Annexure-18 Reconciliation of Power Purchase FY 23-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/35. Annexure-18 Reconciliation of Power Purchase FY 23-24.xlsx",
  },
  {
    name: "36. Annexure-19 Project Progress Report for Pt. no. 1950 of 2023",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/36. Annexure-19 Project Progress Report for Pt. no. 1950 of 2023.pdf",
  },
  {
    name: "37. Annexure-20 Project Wise Fixed Assets Additions in FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/37. Annexure-20 Project Wise Fixed Assets Additions in FY 2023-24.xlsx ",
  },
  {
    name: "38. Annexure-21 Sample Project Details for FY 2023-24 in prescribed formats",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/38. Annexure-21 Sample Project Details for FY 2023-24 in prescribed formats.xlsx",
  },
  {
    name: "39. Annexure-22 SBI MCLR Rates for Finacial Year 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/39. Annexure-22 SBI MCLR Rates for Finacial Year 2023-24.pdf",
  },
  {
    name: "40. Annexure-23 Assets Retirement Details FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/40. Annexure-23 Assets Retirement Details FY 2023-24.xlsx",
  },
  {
    name: "41. Annexure-24 Depreciation as per UPERC Method",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/41. Annexure-24 Depreciation as per UPERC Method.xlsx",
  },
  {
    name: "42. Annexure 24(b)- Additional Depreciation FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/42. Annexure 24(b)- Additional Depreciation FY 2023-24.xlsx",
  },
  {
    name: "43. Annexure-25 Tax Payment Details FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/43. Annexure-25 Tax Payment Details FY 2023-24.pdf",
  },
  {
    name: "44. Annexure-26 Open Access consumer List along with their Consumption & Charges",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/44. Annexure-26 Open Access consumer List along with their Consumption & Charges.xlsx",
  },
  {
    name: "45. Annexure-27 Grant of Additional GNA by CTUIL letter dated 16th July, 2024",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/45. Annexure-27 Grant of Additional GNA by CTUIL letter dated 16th July, 2024.pdf",
  },
  {
    name: "46. Annexure-28 5 Substation Petition no. 2089 of 2024 dated 14th May 2024",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/46. Annexure-28 5 Substation Petition no. 2089 of 2024 dated 14th May 2024.pdf",
  },
  {
    name: "46. Annexure-28 5 Substation Petition no. 2089 of 2024 dated 14th May 2024",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/46. Annexure-28 5 Substation Petition no. 2089 of 2024 dated 14th May 2024.xlsx",
  },
  {
    name: "48. Annexure-29(b) APR FY 24-25 Capital Expenditure Plan  (Less than Rs. 10 Cr)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/48. Annexure-29(b) APR FY 24-25 Capital Expenditure Plan  (Less than Rs. 10 Cr).xlsx",
  },
  {
    name: "49. Annexure-30 DIL email dated 15.10.2024",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/49. Annexure-30 DIL email dated 15.10.2024.pdf",
  },
  {
    name: "50. Annexure-31(a) ARR FY 25-26 Capital Expenditure Plan  (Approved,petitioned Above Rs. 10 Cr)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/50. Annexure-31(a) ARR FY 25-26 Capital Expenditure Plan  (Approved,petitioned Above Rs. 10 Cr).xlsx",
  },
  {
    name: "51. Annexure-31(b) ARR FY 25-26 Capital Expenditure Plan  (Proposed Above Rs. 10 Cr)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/51. Annexure-31(b) ARR FY 25-26 Capital Expenditure Plan  (Proposed Above Rs. 10 Cr).xlsx",
  },
  {
    name: "52. Annexure-31(c) ARR FY 25-26 Capital Expenditure Plan  (Less than Rs. 10 Cr)",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/52. Annexure-31(c) ARR FY 25-26 Capital Expenditure Plan  (Less than Rs. 10 Cr).xlsx",
  },
  {
    name: "53. Annexure-32 Estimation of Consumer Contribution",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/53. Annexure-32 Estimation of Consumer Contribution.xlsx",
  },
  {
    name: "54. Annexure-33 Details of disallowances in Appeal against Tariff Orders",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/54. Annexure-33 Details of disallowances in Appeal against Tariff Orders.xlsx",
  },
  {
    name: "55. Annexure-34 Trial Balance for FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/55. Annexure-34 Trial Balance for FY 2023-24.xlsx",
  },
  {
    name: "56. Annexure-35 Annual Energy Audit Report FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/56. Annexure-35 Annual Energy Audit Report FY 2023-24.pdf",
  },
  {
    name: "57. Annexure-36 Land Lease Deed",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/57. Annexure-36 Land Lease Deed.pdf",
  },
  {
    name: "58. Annexure-37 Details of Unutilised Land",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/58. Annexure-37 Details of Unutilised Land.xlsx",
  },
  {
    name: "59. Annexure-38 Monthwise Billing Determinants FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/59. Annexure-38 Monthwise Billing Determinants FY 2023-24.xlsx",
  },
  {
    name: "60. Annexure-39 Load Curve FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/60. Annexure-39 Load Curve FY 2023-24.xlsx",
  },
  {
    name: "61. Annexure-40 Reconciliation of O&M Expenses",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/61. Annexure-40 Reconciliation of O&M Expenses.xlsx",
  },
  {
    name: "62. Annexure-41 Last five years Billing determinants",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/62. Annexure-41 Last five years Billing determinants.pdf",
  },
  {
    name: "63. Annexure-42 Month Wise Power Purchase Details FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/63. Annexure-42 Month Wise Power Purchase Details FY 2023-24.xlsx",
  },
  {
    name: "64. Annexure-43 Energy Balance",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/64. Annexure-43 Energy Balance.xlsx",
  },
  {
    name: "65. Annexure-44 List of HPO Generators",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/65. Annexure-44 List of HPO Generators.xlsx",
  },
  {
    name: "66. Annexure-45 Evidence of Rate of Interest for CSD for FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/66. Annexure-45 Evidence of Rate of Interest for CSD for FY 2023-24.pdf",
  },
  {
    name: "67. Annexure-46 (a) Soft Copy of NPCL Audited Accounts FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/67. Annexure-46 (a) Soft Copy of NPCL Audited Accounts FY 2023-24.xlsx",
  },
  {
    name: "68. Annexure-46 (b) Soft Copy of NPCL Cost Audit Report FY 2023-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/68. Annexure-46 (b) Soft Copy of NPCL Cost Audit Report FY 2023-24.xlsx",
  },
  {
    name: "69.Annexure-A Copies of Approved Orders,PPA",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/69.Annexure-A Copies of Approved Orders,PPA.pdf",
  },
  {
    name: "70.Annexure-B Power Purchase Bills FInal_1",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/70.Annexure-B Power Purchase Bills FInal_1.pdf",
  },
  {
    name: "70.Annexure-B Power Purchase Bills FInal_2",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/70.Annexure-B Power Purchase Bills FInal_2.pdf",
  },
  {
    name: "70.Annexure-B Power Purchase Bills FInal_3",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/70.Annexure-B Power Purchase Bills FInal_3.pdf",
  },
  {
    name: "70.Annexure-B Power Purchase Bills FInal_4",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/70.Annexure-B Power Purchase Bills FInal_4.pdf",
  },
  {
    name: "70.Annexure-B Power Purchase Bills FInal_5",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/70.Annexure-B Power Purchase Bills FInal_5.pdf",
  },
  {
    name: "70.Annexure-B Power Purchase Bills FInal_6",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/70.Annexure-B Power Purchase Bills FInal_6.pdf",
  },
  {
    name: "70.Annexure-B Power Purchase Bills FInal_7",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/70.Annexure-B Power Purchase Bills FInal_7.pdf",
  },
  {
    name: "70.Annexure-B Power Purchase Bills FInal_8",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/70.Annexure-B Power Purchase Bills FInal_8.pdf",
  },
  {
    name: "70.Annexure-B Power Purchase Bills FInal_9",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/70.Annexure-B Power Purchase Bills FInal_9.pdf",
  },
  {
    name: "70.Annexure-B Power Purchase Bills FInal_10",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/70.Annexure-B Power Purchase Bills FInal_10.pdf",
  },
  {
    name: "70.Annexure-B Power Purchase Bills FInal_11",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/70.Annexure-B Power Purchase Bills FInal_11.pdf",
  },
  {
    name: "70.Annexure-B Power Purchase Bills FInal_12",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/70.Annexure-B Power Purchase Bills FInal_12.pdf",
  },
  {
    name: "70.Annexure-B Power Purchase Bills FInal_13",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/70.Annexure-B Power Purchase Bills FInal_13.pdf",
  },
  {
    name: "89.Annexure C- Fixed Asset Register FY 23-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/89.Annexure C- Fixed Asset Register FY 23-24.pdf",
  },
  {
    name: "89-90. Annexure C- Fixed Asset Register FY 23-24",
    url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/1. Tariff Petition dated 28.11.2024/89-90. Annexure C- Fixed Asset Register FY 23-24.xlsx",
  },
];

const DocumentCard = ({ doc }) => {
  const isExcel =
    doc.url.toLowerCase().endsWith(".xlsx") ||
    doc.url.toLowerCase().endsWith(".xlsb");
  return (
    <a
      href={doc.url}
      target="_blank"
      rel="noopener noreferrer"
      className="document-card"
    >
      <div className={`document-icon ${isExcel ? "excel-icon" : "pdf-icon"}`}>
        {isExcel ? (
          <i className="fa fa-file-excel-o" aria-hidden="true"></i>
        ) : (
          <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
        )}
      </div>
      <span className="document-name">{doc.name}</span>
    </a>
  );
};
const TariffPetetionARR2425 = () => {
  const [activeStep, setActiveStep] = useState(0);
  return (
    <>
      <div id="bodyaddid">
        <Header />
        <FixMenu />
        <section className="main-banner">
          <div
            className="innerpagebanner"
            style={{
              backgroundImage:
                "url(" + "assets/img/inner/cost-data-book.jpg" + ")",
              backgroundSize: "100% auto",
            }}
          ></div>
          <Announcement />
        </section>
        <section className="main_sectiods">
          <div className="container main_bdy">
            <div className="row justify-content-center">
              <div className="col-sm-12">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Home </Link>
                    <span className="icondsds">
                      <i className="fa fa-chevron-right" aria-hidden="true"></i>
                    </span>
                  </li>
                  <li className="breadcrumb-item">
                    <Link
                      to="/NPCL-Tariff-Petition-ARR-2025-26"
                      className="active"
                    >
                      NPCL Tariff Petition for ARR 2025-26
                    </Link>
                  </li>
                </ol>
              </div>
            </div>

            <div className="tariff-stepper-bg">
              <div className="tariff-stepper-container">
                {steps.map((step, idx) => (
                  <React.Fragment key={idx}>
                    <div
                      className={`tariff-stepper-step${activeStep === idx ? " active" : ""
                        }`}
                      onClick={() => setActiveStep(idx)}
                    >
                      <div className="tariff-stepper-title">{step.title}</div>
                      {step.date && (
                        <div className="tariff-stepper-date">{step.date}</div>
                      )}
                    </div>
                    {idx !== steps.length - 1 && (
                      <div className="tariff-stepper-connector" />
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>{" "}

            {activeStep === 0 && (
              <div className="tariff-step-arrow-container">
                <svg
                  className="tariff-step-arrow"
                  viewBox="0 0 60 70"
                  preserveAspectRatio="xMidYMid meet"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M30 5 C15 25, 45 45, 30 65 M30 65 L20 55 M30 65 L40 55"
                    stroke="#295a99"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            )}
            {activeStep === 0 && (
              <>
                <div className="tariff-info-box">
                  <div className="tariff-info-title">
                    Important Information:
                  </div>
                  <div className="tariff-info-text">
                    In accordance with the MYT Regulations, 2025 and as directed
                    by the Hon'ble Commission vide letter no.
                    UPERC/Secy/D(Tariff)/2025-042 dated 15th April, 2025, the
                    Company has submitted a revised ARR Petition for FY 2025–26.
                    Accordingly, certain forms, appendices, and annexures have
                    been updated. Readers are advised to refer tab
                    <a
                      href="#"
                      className="tariff-info-link"
                      onClick={(e) => {
                        e.preventDefault();
                        setActiveStep(1);
                      }}
                    >
                      {" "}
                      "Revised ARR Petition FY 2025-26"
                    </a>{" "}
                    for the revised information.
                  </div>
                </div>
                <div className="all-documents-bg-card">
                  <div className="sample-documents-grid">
                    {revisedArrDocuments.map((doc, idx) => (
                      <DocumentCard key={idx} doc={doc} />
                    ))}
                  </div>
                </div>
              </>
            )}
            {activeStep === 1 && (
              <div className="all-documents-bg-card">
                <div className="sample-documents-grid">
                  {secondStep.map((doc, idx) => (
                    <DocumentCard key={idx} doc={doc} />
                  ))}
                </div>
              </div>
            )}
            {activeStep === 2 && (
              <div className="all-documents-bg-card">
                <div className="sample-documents-grid">
                  {deficiencyNote1.map((doc, idx) => (
                    <DocumentCard key={idx} doc={doc} />
                  ))}
                </div>
              </div>
            )}
            {activeStep === 3 && (
              <div className="all-documents-bg-card">
                <div className="sample-documents-grid">
                  {deficiencyNote2.map((doc, idx) => (
                    <DocumentCard key={idx} doc={doc} />
                  ))}
                </div>
              </div>
            )}
            {activeStep === 5 && (
              <div className="all-documents-bg-card">
                <div className="sample-documents-grid">
                  {deficiencyNote3.map((doc, idx) => (
                    <DocumentCard key={idx} doc={doc} />
                  ))}
                </div>
              </div>
            )}
            {activeStep === 4 && (
              <div className="all-documents-bg-card">
                <div className="sample-documents-grid">
                  {[
                    {
                      name: "0.Index Page - Technical Validation Session (TVS)",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/0. Index Page - Technical Validation Session (TVS).pdf",
                    },
                    {
                      name: "1.Cover Letter_TVS_MoM",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/1.Cover Letter_TVS_MoM.pdf",
                    },
                    {
                      name: "2.Affidavit_TVS MoM",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/2.Affidavit_TVS MoM.pdf",
                    },
                    {
                      name: "3.Appendix-1 Reply to TVS MoM",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/3.Appendix-1 Reply to TVS MoM.pdf",
                    },
                    {
                      name: "4.Annexure-1 Correspondence with Adani",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/4.Annexure-1 Correspondence with Adani.pdf",
                    },
                    {
                      name: "5.Annexure-2 UPSLDC Energy Account_Adani 2023-24",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/5.Annexure-2 UPSLDC Energy Account_Adani 2023-24.pdf",
                    },
                    {
                      name: "5.Annexure-2 UPSLDC Energy Account_Adani 2023-24",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/5.Annexure-2 UPSLDC Energy Account_Adani 2023-24.xlsx",
                    },
                    {
                      name: "6.Annexure-3 Reconciliation of Bills after Feb'2023",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/6.Annexure-3 Reconciliation of Bills after Feb'2023.pdf",
                    },
                    {
                      name: "6.Annexure-3-Reconciliation of Adani Solar",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/6.Annexure-3-Reconciliation of Adani Solar.xlsx",
                    },
                    {
                      name: "7.Annexure-4 Power Exchange Time Block data FY 2023-24",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/7.Annexure-4 Power Exchange Time Block data FY 2023-24.xlsx",
                    },
                    {
                      name: "8.Annexure-5 Reconcilation of Power Purchase Invoices",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/8.Annexure-5 Reconcilation of Power Purchase Invoices.pdf",
                    },
                    {
                      name: "8.Annexure-5 Reconciliation of Power Purchase Cost (FY-24)",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/8.Annexure-5 Reconciliation of Power Purchase Cost (FY-24).xlsx",
                    },
                    {
                      name: "9.Annexure-6 Bifurcation of Transmission charges FY 2023-24",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/9.Annexure-6 Bifurcation of Transmission charges FY 2023-24.xlsx",
                    },
                    {
                      name: "10.Annexure-7 Revised PPC_ARR_FY26",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/10.Annexure-7 Revised PPC_ARR_FY26.xlsx",
                    },
                    {
                      name: "11.Annexure-8 Captive Consumption FY 2025-26",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/11.Annexure-8 Captive Consumption FY 2025-26.xlsx",
                    },
                    {
                      name: "12.Annexure-9 ESR7_BD monthly for FY 2025-26",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/12.Annexure-9 ESR7_BD monthly for FY 2025-26.xlsx",
                    },
                    {
                      name: "13.Annexure-10 Form P1A_DLHT-LT_Final",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/13.Annexure-10 Form P1A_DLHT-LT_Final.xlsx",
                    },
                    {
                      name: "14.Appendix-2 Additional Information of Revised ARR",
                      url: "https://iwebapps.noidapower.com:8032/download/NPCL Tariff Petition for ARR 2025-26/5.Reply to TVS MoM/14.Appendix-2 Additional Information of Revised ARR.pdf",
                    }
                  ].map((doc, idx) => (
                    <DocumentCard key={idx} doc={doc} />
                  ))}
                </div>
              </div>
            )}
            <style>{`
              .tariff-stepper-bg {
                background: #f4f4f6;
                padding: 1.5rem 0 1.2rem 0;
                border-radius: 18px;
                margin-bottom: 2rem;
                overflow-x: visible;
              }
              .tariff-stepper-container {
                display: flex;
                justify-content: center;
                align-items: center;
                gap: 0.5rem;
                padding: 0 1rem;
                position: relative;
                flex-wrap: wrap;
              }
              @media (max-width: 768px) {
                .tariff-stepper-bg {
                  padding: 1rem 0 0.8rem 0;
                  overflow-x: auto;
                  -ms-overflow-style: none;
                  scrollbar-width: none;
                }
                .tariff-stepper-bg::-webkit-scrollbar {
                  display: none;
                }
                .tariff-stepper-container {
                  justify-content: flex-start;
                  flex-wrap: nowrap;
                  overflow-x: auto;
                  -webkit-overflow-scrolling: touch;
                  scrollbar-width: none;
                  -ms-overflow-style: none;
                  padding: 0 0.5rem;
                  gap: 0.3rem;
                }
                .tariff-stepper-container::-webkit-scrollbar {
                  display: none;
                }
                .tariff-stepper-step {
                  min-width: 100px;
                  max-width: 140px;
                  padding: 0.5rem 0.6rem;
                  flex-shrink: 0;
                }
                .tariff-stepper-title {
                  font-size: 0.75rem;
                }
                .tariff-stepper-date {
                  font-size: 0.65rem;
                }
                .tariff-stepper-connector {
                  width: 10px;
                }
              }
              .tariff-stepper-step {
                background: #4074b7;
                color: #fff;
                border-radius: 12px;
                box-shadow: 0 2px 12px rgba(64,116,183,0.13);
                padding: 0.8rem 1rem;
                min-width: 140px;
                max-width: 200px;
                text-align: center;
                font-family: 'Segoe UI', sans-serif;
                font-size: 0.9rem;
                cursor: pointer;
                border: 2.5px solid transparent;
                transition: box-shadow 0.2s, border 0.2s, background 0.2s, color 0.2s;
                position: relative;
                z-index: 2;
                flex: 1;
                word-break: break-word;
                box-sizing: border-box;
                white-space: normal; /* Ensure text wraps */
              }
              .tariff-stepper-step.active {
                background: #fff;
                color: #295a99;
                border: 2.5px solid #295a99;
                box-shadow: 0 4px 24px rgba(64,116,183,0.18);
                font-weight: 700;
              }
              .tariff-stepper-step:hover:not(.active) {
                background: #295a99;
                color: #fff;
                box-shadow: 0 6px 18px rgba(64,116,183,0.18);
              }
              .tariff-stepper-title {
                font-size: 0.9rem;
                font-weight: 600;
                margin-bottom: 0.2rem;
                line-height: 1.2;
              }
              .tariff-stepper-date {
                font-size: 0.8rem;
                font-weight: 400;
                opacity: 0.92;
              }
              .tariff-stepper-connector {
                width: 20px;
                height: 3px;
                background: #4074b7;
                border-radius: 2px;
                margin: 0 0.1rem;
                z-index: 1;
                flex-shrink: 0;
              }
              @media (max-width: 1200px) {
                .tariff-stepper-step {
                  min-width: 120px;
                  max-width: 180px;
                  padding: 0.7rem 0.8rem;
                }
                .tariff-stepper-title {
                  font-size: 0.85rem;
                }
                .tariff-stepper-date {
                  font-size: 0.75rem;
                }
              }
              @media (max-width: 992px) {
                .tariff-stepper-step {
                  min-width: 110px;
                  max-width: 160px;
                  padding: 0.6rem 0.7rem;
                }
                .tariff-stepper-title {
                  font-size: 0.8rem;
                }
                .tariff-stepper-date {
                  font-size: 0.7rem;
                }
                .tariff-stepper-connector {
                  width: 15px;
                }
              }
              @media (max-width: 768px) {
                .tariff-stepper-bg {
                  padding: 1rem 0 0.8rem 0;
                }
                .tariff-stepper-container {
                  gap: 0.3rem;
                }
                .tariff-stepper-step {
                  min-width: 100px;
                  max-width: 140px;
                  padding: 0.5rem 0.6rem;
                }
                .tariff-stepper-title {
                  font-size: 0.75rem;
                }
                .tariff-stepper-date {
                  font-size: 0.65rem;
                }
                .tariff-stepper-connector {
                  width: 10px;
                }
              }
              @media (max-width: 576px) {
                .tariff-stepper-step {
                  min-width: 120px;
                  max-width: 160px;
                  padding: 0.7rem 0.6rem;
                }
                .tariff-stepper-title {
                  font-size: 0.88rem;
                  margin-bottom: 0.2rem;
                }
                .tariff-stepper-date {
                  font-size: 0.82rem;
                }
                .tariff-stepper-connector {
                  width: 20px;
                  height: 3px;
                }
              }
              @media (max-width: 400px) {
                .tariff-stepper-step {
                  min-width: 110px;
                  max-width: 140px; /* Adjusted max-width */
                  padding: 0.6rem 0.5rem;
                }
                .tariff-stepper-title {
                  font-size: 0.85rem;
                }
                .tariff-stepper-date {
                  font-size: 0.8rem;
                }
                .tariff-stepper-connector {
                  width: 15px;
                }
              }
              /* Styles for the arrow container */
              .tariff-step-arrow-container {
                // position:
                top: calc(100% - 10px); /* Position below the stepper, adjusted for spacing */
                left: 0;
                width: 100%;
                display: flex;
                // justify-content: flex-start; /* Align arrow to the start */
                // pointer-events: none;
                z-index: 1;
                margin-top: -71px;
              }
              /* Styles for the arrow SVG */
              .tariff-step-arrow {
                width: 40px;
                height: 80px;
                flex-shrink: 0;
                /* Calculate horizontal position to be under the center of the first step */
                /* Calculation: left padding of container + (min-width of step / 2) - (arrow width / 2) */
                transform: translateX(calc(1rem + (180px / 2) - (40px / 2)));
              }
              @media (max-width: 1200px) {
                .tariff-stepper-step {
                   min-width: 160px;
                   max-width: 220px;
                }
                .tariff-step-arrow {
                   transform: translateX(calc(1rem + (160px / 2) - (40px / 2))); /* Adjust transform based on min-width */
                }
              }
              @media (max-width: 992px) {
                .tariff-stepper-step {
                   min-width: 140px;
                   max-width: 200px;
                   padding: 0.9rem 0.8rem;
                }
                .tariff-step-arrow {
                   transform: translateX(calc(1rem + (140px / 2) - (35px / 2))); /* Adjust transform and arrow width/height */
                   width: 35px;
                   height: 45px;
                }
              }
               @media (max-width: 768px) {
                 .tariff-stepper-step {
                   min-width: 130px;
                   max-width: 180px;
                   padding: 0.8rem 0.7rem;
                 }
                .tariff-step-arrow {
                   transform: translateX(calc(0.5rem + (130px / 2) - (30px / 2))); /* Adjust transform and arrow width/height based on smaller screen styles */
                   width: 30px;
                   height: 40px;
                }
              }
              @media (max-width: 576px) {
                 .tariff-stepper-step {
                   min-width: 120px;
                   max-width: 160px;
                   padding: 0.7rem 0.6rem;
                }
                .tariff-step-arrow {
                   transform: translateX(calc(0.5rem + (120px / 2) - (25px / 2))); /* Adjust transform and arrow width/height */
                   width: 25px;
                   height: 35px;
                }
              }
              @media (max-width: 400px) {
                 .tariff-stepper-step {
                   min-width: 110px;
                   max-width: 140px;
                   padding: 0.6rem 0.5rem;
                }
                .tariff-step-arrow {
                   transform: translateX(calc(0.5rem + (110px / 2) - (20px / 2))); /* Adjust transform and arrow width/height */
                   width: 20px;
                   height: 30px;
                }
              }
              .tariff-info-box {
                background: #fff;
                border-left: 5px solid #4074b7;
                box-shadow: 0 2px 16px rgba(64,116,183,0.10);
                border-radius: 12px;
                padding: 1.5rem;
                margin: 2.5rem auto;
                // max-width: 1050px;
                margin-top: -1px;
                font-family: 'Segoe UI', sans-serif;
                animation: fadeIn 0.5s;
              }
               
              .tariff-info-title {
                font-size: 1.13rem;
                font-weight: 700;
                color: #295a99;
                margin-bottom: 0.7rem;
                letter-spacing: 0.01em;
              }
              .tariff-info-text {
                font-size: 1.01rem;
                color: #222;
                line-height: 1.7;
              }
              .tariff-info-link {
                color: #4074b7;
                font-weight: 600;
                text-decoration: underline;
                margin-left: 0.3rem;
                transition: color 0.2s;
                cursor: pointer;
              }
              .tariff-info-link:hover {
                color: #295a99;
                text-decoration: underline wavy;
              }
              @keyframes fadeIn {
                from { opacity: 0; transform: translateY(20px); }
                to { opacity: 1; transform: translateY(0); }
              }
              @media (max-width: 700px) {
                .tariff-info-box {
                  padding: 1.1rem 0.7rem 1rem 0.9rem;
                  max-width: 98vw;
                }
                .tariff-info-title {
                  font-size: 1.01rem;
                }
                .tariff-info-text {
                  font-size: 0.97rem;
                }
              }
              .sample-documents-grid {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
                gap: 10px;
                margin-bottom: 20px;
              }
              .document-card {
                background: white;
                border-radius: 6px;
                padding: 8px 12px;
                display: flex;
                align-items: center;
                gap: 10px;
                cursor: pointer;
                transition: all 0.2s ease;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                border: 1px solid #e0e0e0;
                text-decoration: none;
              }
              .document-card:hover {
                transform: translateY(-2px);
                box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
                border-color: #2196f3;
              }
              .document-icon {
                padding: 8px;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .document-icon .fa {
                font-size: 18px;
              }
              .pdf-icon {
                background: #e3f2fd;
                color: #2196f3;
              }
              .excel-icon {
                background: #e8f5e9;
                color: #2e7d32;
              }
              .document-card:hover .pdf-icon {
                background: #bbdefb;
              }
              .document-card:hover .excel-icon {
                background: #c8e6c9;
              }
              .document-card:hover .pdf-icon .fa {
                color: #1976d2;
              }
              .document-card:hover .excel-icon .fa {
                color: #1b5e20;
              }
              .document-name {
                font-size: 12px;
                color: #333;
                font-weight: 500;
                flex: 1;
                line-height: 1.2;
              }
              @media (max-width: 768px) {
                .sample-documents-grid {
                  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
                }
                .document-name {
                  font-size: 12px;
                }
              }
              .all-documents-bg-card {
                background: #fff;
                border-radius: 18px;
                box-shadow: 0 4px 32px rgba(64,116,183,0.10);
                padding: 2.5rem 2rem;
                margin: 2.5rem auto;
                max-width: 1200px;
                min-width: 0;
              }
              @media (max-width: 900px) {
                .all-documents-bg-card {
                  padding: 1.2rem 0.5rem;
                  max-width: 99vw;
                }
              }
            `}</style>
          </div>
        </section>
      </div>
    </>
  );
};
export default TariffPetetionARR2425;
